<template>
  <b-row v-if="renderPage">
    <b-container>
      <b-overlay
        :show="showLoading"
        :opacity="1"
        variant="light"
        rounded="sm"
      >
        <template v-slot:overlay>
          <div class="d-flex align-items-center">
            <strong>Enviando Arquivo, Aguarde...</strong>
            <b-icon
              icon="stopwatch"
              font-scale="3"
              animation="cylon"
            />
            <b-spinner
              small
              type="grow"
              variant="primary"
            />
            <b-spinner
              type="grow"
              variant="primary"
            />
            <b-spinner
              small
              type="grow"
              variant="primary"
            />
          </div>
        </template>
        <b-card title="Importação Arquivos Rede">
          <validation-observer
            ref="uploadRede"
            #default="{ invalid }"
          >
            <b-form>
              <b-form-group
                label="Tipo do Arquivo"
                label-for="v-file"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Upload"
                  rules="required"
                >
                  <v-select
                    v-model="selectedFileOption"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :options="redeFileOptions"
                    placeholder="Selecione o Tipo do Arquivo"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="Upload"
                  :rules="`required|${
                    selectedFileOption.title === &quot;Clientes&quot; ? &quot;fileUploadClient&quot;
                    : selectedFileOption.title === &quot;Bancário&quot; ? &quot;fileUploadBank&quot;
                      : &quot;&quot;
                  }`"
                >
                  <b-form-file
                    v-model="file"
                    placeholder="Arraste ou selecione um arquivo"
                    drop-placeholder="Arraste o arquivo aqui."
                    :disabled="isDisabledFile"
                  />

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-button
                variant="primary"
                :disabled="invalid"
                class="btn-upload"
                @click="upload"
              >
                Enviar Arquivo
              </b-button>
            </b-form>
          </validation-observer>
        </b-card>
      </b-overlay>
    </b-container>
  </b-row>
</template>

<script>
import {
  BFormFile,
  BFormGroup,
  BButton,
  BRow,
  BCard,
  BContainer,
  BForm,
  BSpinner,
  BOverlay,
  BIcon,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

import { ValidationProvider, ValidationObserver } from 'vee-validate'

import { required, email } from '@validations'
import { uploadIndicator, uploadClients, uploadBanking } from '@/service/file/archiveRede'

export default {
  components: {
    BFormFile,
    BFormGroup,
    BButton,
    BRow,
    BCard,
    BContainer,
    BForm,
    vSelect,
    BSpinner,
    BOverlay,
    BIcon,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      file: null,
      showLoading: false,
      selectedFileOption: {
        title: 'Selecione o Tipo de Arquivo',
      },
      redeFileOptions: [
        { title: 'Indicadores' },
        { title: 'Clientes' },
        { title: 'Bancário' },
      ],
      renderPage: true,
      required,
      email,
    }
  },
  beforeRouteLeave(to, from, next) {
    this.renderPage = false
    next()
  },
  computed: {
    isDisabledFile() {
      return this.selectedFileOption.title === 'Selecione o Tipo de Arquivo'
    },
  },
  methods: {
    async upload() {
      this.showLoading = true
      const timeOut = ms => new Promise(r => setTimeout(r, ms))
      const responseRequest = response => ((response === 200) ? this.success() : this.error())
      const { file, selectedFileOption: { title } } = this
      const timeInMinutes = 3

      switch (title) {
        case 'Indicadores': {
          responseRequest(await uploadIndicator(file))
          break
        }

        case 'Clientes': {
          responseRequest(await uploadClients(file))
          break
        }

        case 'Bancário': {
          responseRequest(await uploadBanking(file))
          break
        }

        default: {
          this.error()
          break
        }
      }
      this.cleanInputs()
    },
    success() {
      this.showLoading = false
      this.$swal({
        icon: 'success',
        html: '<span>O Arquivo foi Enviado com Sucesso </span> ',
      })
    },
    error() {
      this.showLoading = false
      this.$swal({
        icon: 'error',
        html: '<span>Não foi possível enviar o arquivo</span> ',
      })
    },
    cleanInputs() {
      this.file = null
    },
  },
}
</script>
<style lang="scss">
  @import "@core/scss/vue/pages/upload-style.scss";
</style>
